'use strict';

var Mapper = require('./Mapper.js');
var YourDetailsHelpers = require('./YourDetailsHelpers');
var YourDetailsConstants = require('../constants/YourDetailsConstants');
var ApplicationConstants = require('../constants/ApplicationConstants.js');
var Values = ApplicationConstants.YesNoValues;
var MappingConfigurations = YourDetailsConstants.MappingConfigurations;

var componentsRetrieveService = {
    loadYourDetails: function (yourDetails, formData) {
        if (formData){
            Mapper.objectMerger(formData, yourDetails);
            if (formData.title){
              formData.title = formData.title.toString();
            }
        }
    },
    loadResidentialAddressInfo: function (data, addressInfo) {
        if (addressInfo){
            var address = Mapper.ObjectMapperConfigValuesAsKeys(data, MappingConfigurations.ResidentialAddressSave);
            Mapper.objectMerger(addressInfo, address);
            if (!addressInfo.residential && (addressInfo.address1 || addressInfo.address2 || addressInfo.cityStatePostCode || addressInfo.resCountry)) {
                addressInfo.defineAddressLine = Values.YES;
            }
        }
    },
    loadPostalAddressInfo: function (yourDetails, addressInfo) {
        if (addressInfo){
            var address = Mapper.ObjectMapperConfigValuesAsKeys(yourDetails.postalAddress, MappingConfigurations.PostalAddressSave);
            Mapper.objectMerger(addressInfo, address);
            if (!addressInfo.postal && (addressInfo.postalAddress1 || addressInfo.postalAddress2 || addressInfo.postalCityStatePostCode || addressInfo.postalCountry)) {
                addressInfo.definePostalAddressLine = Values.YES;
            }
        }
    },
    loadContactDetails: function (yourDetails, contactDetails) {
        if (yourDetails.contactDetails){
            contactDetails.mobileNumber = yourDetails.contactDetails.mobile || '';
            contactDetails.mobileNumberReadonly = yourDetails.contactDetails.mobileReadonly;
            contactDetails.homeNumber = yourDetails.contactDetails.home || '';
            contactDetails.homeNumberReadonly = yourDetails.contactDetails.homeReadonly;
            contactDetails.workNumber = yourDetails.contactDetails.work || '';
            contactDetails.workNumberReadonly = yourDetails.contactDetails.workReadonly;
            contactDetails.emailAddress = yourDetails.contactDetails.email || '';
            contactDetails.emailAddressReadonly = yourDetails.contactDetails.emailReadonly;
        }
    },
    loadTfn: function (yourDetails, tfn) {
        if (yourDetails.tfnInfo){
            tfn.tfnNumber = yourDetails.tfnInfo.tfnNumber || '';
            tfn.tfnNumberReadonly = yourDetails.tfnInfo.tfnNumberReadonly;
            tfn.tfnExemptionReason = yourDetails.tfnInfo.exemptionReason || '';
            tfn.tfnExemptionReasonReadonly = yourDetails.tfnInfo.exemptionReasonReadonly;
            tfn.hasTfnExemption = yourDetails.tfnInfo.hasTfnExemption;
            tfn.hasTfnExemptionReadonly = yourDetails.tfnInfo.exemptionReasonReadonly;
            tfn.tfnConsentFlag = yourDetails.tfnInfo.tfnConsentFlag;
            tfn.tfnWithConsent = yourDetails.tfnInfo.tfnWithConsent;
        }
    },
    loadCountryOfResidence: function (yourDetails, countryOfResidenceInfo) {
        if (countryOfResidenceInfo){
            var countryOfResidence = Mapper.ObjectMapperConfigValuesAsKeys(yourDetails.countryOfResidence, MappingConfigurations.CountryOfResidenceSave);
            Mapper.objectMerger(countryOfResidenceInfo, countryOfResidence);
        }
    },
    loadOtherCountryTaxResidence: function (yourDetails, otherCountryTaxResidenceInfo) {
        if (otherCountryTaxResidenceInfo){
            var taxResidence = Mapper.ObjectMapperConfigValuesAsKeys(yourDetails.taxResidence, MappingConfigurations.TaxResidenceSave);
            Mapper.objectMerger(otherCountryTaxResidenceInfo, taxResidence);

            if (taxResidence.countries) {
                
                for (var i = 1; i <= taxResidence.countries.length; i++) {
                    otherCountryTaxResidenceInfo['otherCountryTaxResidence' + i] = taxResidence.countries[i-1].country;
                    otherCountryTaxResidenceInfo['tin' + i] = taxResidence.countries[i-1].tin;
                    otherCountryTaxResidenceInfo['tinExemptionReason' + i] = taxResidence.countries[i-1].tinExemptionReason;
                    if (i === 1) {
                        otherCountryTaxResidenceInfo['otherCountryTaxResidenceReadonly'] = taxResidence.countries[i-1].countryReadonly;
                    }
                }
            }
        }
    },
    loadCitizenship: function (yourDetails, citizenshipInfo) {
        if (citizenshipInfo){
            var citizenship = Mapper.ObjectMapperConfigValuesAsKeys(yourDetails.citizenship, MappingConfigurations.CitizenshipSave);
            Mapper.objectMerger(citizenshipInfo, citizenship);
        }
    },
    loadOccupation: function (yourDetails, occupationInfo) {
        if (occupationInfo){
            var occupation = Mapper.ObjectMapperConfigValuesAsKeys(yourDetails.occupation, MappingConfigurations.OccupationSave);
            Mapper.objectMerger(occupationInfo, occupation);
        }
    },
    loadAccountDesignation: function (yourDetails, formData) {
        if (yourDetails.accountDesignation) {
            formData.isAccountDesignation = yourDetails.accountDesignation.isAccountDesignation;
            formData.accountDesignationName = yourDetails.accountDesignation.accountDesignationName;
        }
    }
}

var retrieveYourDetails = function (yourDetails, formData) {
    componentsRetrieveService.loadYourDetails(yourDetails, formData);
    componentsRetrieveService.loadResidentialAddressInfo(yourDetails.residentialAddress, formData.addressInfo);
    componentsRetrieveService.loadPostalAddressInfo(yourDetails, formData.addressInfo);
    componentsRetrieveService.loadContactDetails(yourDetails, formData);
    componentsRetrieveService.loadTfn(yourDetails, formData);
    componentsRetrieveService.loadCountryOfResidence(yourDetails, formData);
    componentsRetrieveService.loadOtherCountryTaxResidence(yourDetails, formData);
    componentsRetrieveService.loadCitizenship(yourDetails, formData);
    componentsRetrieveService.loadOccupation(yourDetails, formData);
    componentsRetrieveService.loadResidentialAddressInfo(yourDetails.businessAddress, formData.businessAddress);
    componentsRetrieveService.loadPostalAddressInfo(yourDetails, formData.businessAddress);
    componentsRetrieveService.loadAccountDesignation(yourDetails, formData);
}


var retrieveInvestorList = function (yourDetails, investorList) {
    if (yourDetails && yourDetails.investorList) {
        for (var i = 0; i < yourDetails.investorList.length; i++) {
            var investor = YourDetailsHelpers.createNewInvestor(i, YourDetailsConstants.InvestorType.INVESTOR);

            retrieveYourDetails(yourDetails.investorList[i], investor)

            investorList.push(investor);
        }
    }
}

var retrieveTrusteeList = function (yourDetails, trusteeList) {
    if (yourDetails && yourDetails.trusteeList) {
        for (var i = 0; i < yourDetails.trusteeList.length; i++) {
            var trustee;
            if (yourDetails.trusteeList[i].trusteeType === YourDetailsConstants.TrusteeType.CORPORATE) {
                trustee = YourDetailsHelpers.createNewInvestor(i, YourDetailsConstants.InvestorType.TRUSTEE, true);
            } else {
                trustee = YourDetailsHelpers.createNewInvestor(i, YourDetailsConstants.InvestorType.TRUSTEE, false);
            }

            retrieveYourDetails(yourDetails.trusteeList[i], trustee)

            trusteeList.push(trustee);
        }
    }
}

module.exports = {
    retrieveYourDetails: retrieveYourDetails,
    retrieveInvestorList: retrieveInvestorList,
    retrieveTrusteeList: retrieveTrusteeList,
    componentsRetrieveService: componentsRetrieveService
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/YourDetailsRetrieve.js